import { useMemo } from 'react';
import { TypeAheadFilter } from './TypeAheadFilter';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { useJurisdictions } from '@services/jurisdiction/useJurisdictions';

export interface JurisdictionTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

export const JurisdictionTypeaheadFilter = (componentProps: JurisdictionTypeaheadFilterProps) => {
  const { value, disabled } = componentProps;

  const { jurisdictions } = useJurisdictions({
    enabled: true,
  });

  const items = useMemo(() => {
    return jurisdictions.map((j) => ({
      key: j.id,
      label: j.abbreviation,
      subLabel: j.name ?? 'cat',
      value: j.id,
    }));
  }, [jurisdictions]);

  return (
    <TypeAheadFilter
      value={value}
      defaultValue={value}
      disabled={disabled}
      label={componentProps.label}
      options={items ?? []}
      isMultiple={componentProps?.fieldConfig?.selectField?.multiSelect}
      limitTags={componentProps?.fieldConfig?.selectField?.limitTags ?? 1}
      onChange={componentProps.onChange}
      horizontalLabel={true}
    />
  );
};
